var React = require('react');

function IconHistory (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M506.5 127.2c-140.2.7-262.5 77.2-328.1 190.6l-116 1.1 155.8 152.8c3.9 3.9 10.3 3.8 14.1-.1l152.8-155.8-121.9 1.2c58-76 149-125 251.5-125 175.1 0 317.1 143.2 317.1 319.8s-142 319.8-317.1 319.8C361.4 831.7 233.5 721.9 204 576h-70.5c32 178.1 187.7 313.2 375 313.2 212.3 0 384.1-173.7 381-386.7-3.1-208.5-174.5-376.4-383-375.3z","key":0}),React.createElement("path",{"d":"M661.7 575.9c5.5 0 10-4.5 10-10v-43.2c0-5.5-4.5-10-10-10H542.9V394c0-5.5-4.5-10-10-10h-43.2c-5.5 0-10 4.5-10 10v172c0 5.5 4.5 10 10 10","key":1})]);
}

IconHistory.displayName = "IconHistory";

IconHistory.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconHistory;

IconHistory.default = IconHistory;
